<template>
    <div>
        <div v-if="entities && entity_type" style="border: 2px solid #66359b;padding:3px">
            <GenericTableEditableComponent :data="entities_data" :headers="headers" 
                    :editable_fields="editable_fields"
                    @save="(data) => saveInstances(data)"
                    :loading="loading_save" >
            </GenericTableEditableComponent>
        </div>
    </div>
  </template>
    
  <script>
  import GenericTableEditableComponent from '@/components/GenericTableEditableComponent.vue'
  import RecursivePayloadOnSchemaEditor from '@/modules/entities/infra/RecursivePayloadOnSchemaEditor.vue'
  import { EntityInstanceApiRepository, EntityTypeApiRepository } from '@/modules/entities/infra/EntitiesApiRepositories'
  export default {
      name: "ListOfInstancesEditor",
      components: {
        RecursivePayloadOnSchemaEditor,
        GenericTableEditableComponent
      },
      data() {
        return {
            entity_inst_repo: null,
            entity_type_repo: null,
            entities: null,
            entity_type: null,
            loading_save: false,
        }
      },
      props: {
        entity_instances_ids: {
          type: Array,
          required: true,
        },
        intern_key: {
          type: String,
          required: false,
          default: '',
        },
      },
      async mounted() {
        this.entity_inst_repo = new EntityInstanceApiRepository();
        this.entity_type_repo = new EntityTypeApiRepository();
        await this.loadEntity();
        
      },
      methods: {
        async loadEntity(){
            this.entities = await this.entity_inst_repo.get_multiple_instances(this.entity_instances_ids);
            this.entity_type = await this.entity_type_repo.get_type_by_id(this.entities[0].entity_type_id, true);
            // console.log('entities')
            // console.log(this.entities)
            // console.log('type')
            // console.log(this.entity_type)
            
          //this.composed_key = this.key_to_show + ' ('+this.entity_type.name+')';
        },
        async saveInstances(data){
            console.log('saveInstances')
            console.log(data)
            for(let payload of data){
                let entity = this.entities.find(entity => entity.uuid === payload.uuid);
                delete payload.uuid;
                entity.payload = payload;
            }
            this.loading_save = true;
            await this.entity_inst_repo.update_multiple_instances(this.entities);
            this.loading_save = false;
        },
        get_title_from_key(key){
            return this.entity_type.schema.properties[key].title || key;
        }
      },
      computed: {
        headers(){
            return Object.keys(this.entity_type.schema.properties).map(key => ({ text: this.get_title_from_key(key), value: key }));
        },
        entities_data(){
            return this.entities.map(entity => {
                return {
                    ...entity.payload,
                    uuid: entity.uuid
                }
            });
        },
        editable_fields(){
            //only keys that end with _e
            return this.headers.map(header => header.value).filter(key => key.endsWith('_e'));
        }
      }
      
    };
    </script>
    
    <style scoped>
    .nested-section {
      padding-left: 10px;
      /*border-left: 1px solid #ccc; */
      margin-top: 10px;
    }
    </style>
    